import React from 'react';
import { Container, Col, FormControl, InputGroup, Row, FormCheck, Alert } from 'react-bootstrap';
import '../../../styles/BodyInfo.css';
import { HHIEButton } from '../../utility/HHIEButton';

export default function BodySubmit(props) {
    const [onHold, setOnHold] = React.useState(props.member.passStatus.onHold);
    const [notes, setNotes] = React.useState(props.member.passStatus.notes);
    const [showAlert, setShowAlert] = React.useState(false);
    const [completedAlert, setCompletedAlert] = React.useState(false);
    const totalCharacters = 4000;
    const [charactersLeft, setCharactersLeft] = React.useState(totalCharacters - props.member.passStatus.notes.length);


    function handleNoteEdit(event) {
        setNotes(event.target.value);
        setCharactersLeft(totalCharacters - (event.target.value.length));
    }

    function handleOnHoldCheck(e) {
        setOnHold(e.target.checked);
    }

    function handleSubmit() {
        props.member.passStatus.onHold = onHold;
        props.member.passStatus.notes = notes;


        const requestOptions = {
            method: "POST",
            body: JSON.stringify(props.member.passStatus),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        fetch('api/pass/notes', requestOptions)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                        if (json.message === true) {
                            setCompletedAlert(true);
                        }
                        else {
                            alert('Failure. What did you do?');
                        }
                    })
                    .catch((error) => {
                        console.log("text error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Count response error: " + error);
            });

    }

    var holdDate = props.member.passStatus.onHoldTimeStamp.split('T')[0].split('-');

    return (
        <>
            <Container className="style-box">
                <Row>
                    <Col>
                        <div className="style-body" style={{ backgroundColor: 'orange' }}>PASS Messages On Hold</div>
                        <FormCheck style={{ textIndent: "20px" }} id={"modal-check"} defaultChecked={props.member.passStatus.onHold} onChange={e => { handleOnHoldCheck(e) }} />
                    </Col>
                    {(props.member.passStatus.onHold) ?
                        <Col className="d-flex justify-content-end">
                            <div className="style-body"> On Hold Since </div>
                            {holdDate[1] + '/' + holdDate[2] + '/' + holdDate[0]}
                        </Col>
                        : ""}
                </Row>
                {/* Notes  */}
                <Row>
                    <Col><div className="style-body">Notes</div></Col>
                </Row>
                <Row className="notes-container">
                    <Col>
                        <InputGroup>
                            <FormControl
                                as="textarea"
                                rows={4}
                                id="noteInput"
                                maxLength={totalCharacters}
                                aria-label="With textarea"
                                value={notes}
                                onChange={handleNoteEdit}
                            />
                        </InputGroup>
                        <small className="d-flex justify-content-end form-text text-muted"
                            style={{ fontSize: 10 }}
                        >{charactersLeft + "/" + totalCharacters}</small>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                    <HHIEButton
                        onClick={
                            () => { setShowAlert(true) }
                        }
                        variant="primary"
                        size="sm"
                        title="Save"
                        long="true"
                    />
                </Row>
                <Container className="d-flex justify-content-center">
                    <Alert show={completedAlert} variant='warning' style={{ paddingLeft: 50, paddingRight: 50 }} transition={false}>
                            <p className="d-flex justify-content-center">Submitted</p>
                            <hr />
                            <Row>
                                <Col className="d-flex justify-content-center">
                                    <HHIEButton 
                                        onClick={() => { setCompletedAlert(false) }} 
                                        variant='secondary'
                                        title="Close"
                                    />
                                </Col>
                            </Row>
                        </Alert>
                    <Alert show={showAlert} variant='warning' style={{ paddingLeft: 50, paddingRight: 50 }} transition={false}>
                            <p className="d-flex justify-content-center">Are you sure you want to submit?</p>
                            <hr />
                            <Row>
                                <Col className="d-flex justify-content-end">
                                    <HHIEButton 
                                        onClick={() => { setShowAlert(false); handleSubmit() }} 
                                        variant='secondary'
                                        title="Yes"
                                    />
                                </Col>
                                <Col className="d-flex justify-content-start">
                                    <HHIEButton 
                                        onClick={() => { setShowAlert(false) }} 
                                        variant='secondary'
                                        title="No"
                                    />
                                </Col>
                            </Row>
                        </Alert>
                </Container>
            </Container>
        </>
    )
}